import { type StyledComponent, styled } from 'styled-components'

export const PROFICIENCY_COLORS = ['#ff6f1e', '#FEE75C', '#98eb43', '#38f9ff']

export const ColorLevel: StyledComponent<
	{ level: number },
	{||},
	HTMLDivElement
> = styled.div`
	background: ${({ level }) =>
		level ? PROFICIENCY_COLORS[level - 1] : `#3f3b6e`};
	color: #000 !important;
	${({ level }) =>
		!level &&
		`
	color: #ffffff66 !important;
	font-size: 1.8em !important;

	`}}
`

export const ColorCoin: StyledComponent<{||}, {||}, any> = styled(ColorLevel)`
	border-radius: 50%;
	aspect-ratio: 1 / 1;
	width: 24px;
	margin-right: var(--spacing);
`
